import React, { useEffect, useRef } from "react";
import * as motion from "motion/react-client";
import { useDispatch, useSelector } from "react-redux";
import { playbackSelected } from "slice/playbackSlice";
import { getvideoPath } from "slice/videoPathSlice";
import { clearVideoResponse, getvideoResponse } from "slice/videoResponseSlice";

export const Video = () => {
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const valueCamera = useSelector((state) => state.playback.valueCamera);
  const selectedVideo = useSelector((state) => state.playback.selected);
  const { datavideoPath } = useSelector((state) => state.videoPath.videoPath);
  // console.log(selectedVideo, "selectedVideo");
  // console.log(datavideoPath?.data, "datavideoPath");
  useEffect(() => {
    if (valueCamera?.videoPath) {
      dispatch(getvideoPath({ videoPath: valueCamera?.videoPath }));
    }
  }, [dispatch, valueCamera]);

  useEffect(() => {
    if (datavideoPath?.data?.length >= 2) {
      const json = datavideoPath?.data[0]?.name;
      const path = datavideoPath?.data[1]?.name;

      if (json && path) {
        const newFilename = json.replace(".mp4", "");

        dispatch(playbackSelected(`${datavideoPath?.url}/${json}`));
        dispatch(getvideoResponse({ path: newFilename, json: path }));
      } else {
        console.error("Error: Missing data in video path array");
      }
    } else {
      dispatch(clearVideoResponse([]));
      dispatch(
        playbackSelected(
          `https://facereco.grit.id:9004/${valueCamera?.videoPath}/${valueCamera?.videoPath}.mp4`
        )
      );
      console.error("Error: Data array is too short or invalid");
    }
  }, [dispatch, datavideoPath, valueCamera?.videoPath]);

  return (
    <motion.div
      // style={ball}
      key={selectedVideo}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div className="text-white w-full h-full gap-4 p-4 ">
        <div className="relative ">
          <div className="absolute inset-0 pointer-events-none ">
            <div className="absolute top-0 z-10 w-full border-t-2 border-mo-button"></div>
            <div className="absolute bottom-0 z-10 w-full border-b-2 border-mo-button"></div>
            <div className="absolute left-0 z-10 h-full border-l-2 border-mo-button"></div>
            <div className="absolute right-0 z-10 h-full border-r-2 border-mo-button"></div>
          </div>
          <div className="absolute inset-0 pointer-events-none ">
            <div className="absolute top-0 left-0 z-20 w-4 h-4 border-t-4 border-l-4 border-mo-text"></div>
            <div className="absolute top-0 right-0 z-20 w-4 h-4 border-t-4 border-r-4 border-mo-text"></div>
            <div className="absolute bottom-0 left-0 z-20 w-4 h-4 border-b-4 border-l-4 border-mo-text"></div>
            <div className="absolute bottom-0 right-0 z-20 w-4 h-4 border-b-4 border-r-4 border-mo-text"></div>
          </div>
          <div className="flex bg-black p-5 gap-4 h-custom-heights">
            <div className={` flex flex-col h-full w-full overflow-hidden`}>
              <div className="flex justify-between mb-2">
                <div className="flex items-center gap-2">
                  <img src="/asset/logoVideo.svg" width={20} alt="Icon" />
                  <div>{valueCamera?.nama_video}</div>
                </div>
                <div className="flex gap-2">
                  {/* <img
                    src="/asset/littleBox.svg"
                    width={20}
                    alt="Settings Icon"
                  /> */}
                </div>
              </div>
              <div className="flex flex-col items-center h-full grow-0 justify-center ">
                {datavideoPath ? (
                  <div className="relative w-full max-w-full h-full max-h-full">
                    {datavideoPath?.url && (
                      <div className="text-center text-black absolute  flex items-center justify-center top-0 bottom-0 w-full h-custom-video">
                        {valueCamera?.isActive === true ? (
                          <video
                            type={"video/mp4"}
                            ref={videoRef}
                            controls
                            loop
                            id={`video-${valueCamera?.videoUuid}`}
                            playsInline
                            muted
                            autoPlay
                            src={selectedVideo}
                            crossOrigin="anonymous"
                            style={{
                              height: "100%",
                              width: "100%",
                            }}
                            className="absolute "
                          ></video>
                        ) : valueCamera?.isActive === "NotNetwork" ? (
                          <img
                            src="/asset/giphy.gif"
                            alt="Background"
                            className="w-full h-full object-fill"
                          />
                        ) : (
                          <img
                            src="/asset/loadingBackroundVideo.png"
                            alt="Background"
                            className="w-full h-full object-fill"
                          />
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center text-black bg-stone-200 flex flex-col items-center justify-center top-0 bottom-0 w-full h-full">
                    <div className="text-center text-black font-semibold left-0 right-0">
                      No cam selected.
                    </div>
                    <p className="font-light mt-2 text-sm">
                      Select valueCamera to start monitoring.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
